//@ts-ignore
import { Spinner } from 'reactstrap'
import { SpinnerWrapper } from '../../../styles/common'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Notification } from './Notification'
//@ts-ignore
import { Button } from 'dsm-react-lib'

export const Notifications: React.FC = ({ toggle, appIcons }: any) => {
  const getAppIcon = (id: number) => {
    return appIcons?.filter((icon: any) => icon.applicationId === id)[0]?.appIconUrl
  }
  const allNotifications = useSelector(
    (state: any) => state.notificationContextReducer.notificationContext
  )
  const context = allNotifications.notifications.filter(
    (sidebar: any) => sidebar.notificationType === 'SideScreen'
  )

  return (
    <div className="h-100 overflow-auto">
      {appIcons && context ? (
        context.length === 0 ? (
          <div className="d-flex justify-content-center p-2 text-base text-subheading">
            No new notification
          </div>
        ) : (
          <>
            {context.slice(0, 50).map((item: any) => {
              return (
                <Notification
                  key={item.uniqueId}
                  item={item}
                  icon={getAppIcon(item.applicationId)}
                  toggle={toggle}
                />
              )
            })}
            <div className="mx-1 my-1">
              <Link to="/notifications" className="nav-link px-0">
                <Button label="See more" color="primary" block onClick={() => toggle()}></Button>
              </Link>
            </div>
          </>
        )
      ) : (
        <SpinnerWrapper>
          <Spinner color="primary" />
        </SpinnerWrapper>
      )}
    </div>
  )
}
